<template>
    <div class="com-product-wp">
        <el-row :gutter="20">
                <el-col v-for="(item,index) in list" :key="index" :span="num" >
                     <el-card class="box-card pointer" shadow="hover"  @click.native="getDetail(item.id)"  :body-style="{ padding: '0px' }" >
                        <el-image style="width: 100%; height: 200px;padding-top:10px;" :src="item.fgpic" fit="contain" >
                            <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                <img style="object-fit: fill;width:100%;height:100%;"  src="../assets/image/home/home-img3.png">
                            </div> -->
                        </el-image>
                        <p class="p1 p-lv">{{item.infoTitle}}</p>
                         <p class="p2 p-lv-2">{{item.abstract}}</p>
                        <p class="p3 p-lv">{{item.fgdw}}</p>
                    </el-card>
                </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return{
        }
    },
    props:{
        list:{
            default(){
                return[];
            }
        },
        title:{
            default:'',
        },
        num:{
            default:6
        }

    },
    methods:{
        getDetail(id){
            this.$emit('getDetail',id,this.title);
        }
    }

}
</script>
<style lang="scss" scoped>
.com-product-wp{
    width:100%;
    height:calc(100% - 46px);
    box-sizing: border-box;
    padding:0 10px;
}
.box-card{
        position: relative;
        width:100%;
        height:350px;
        margin-top:35px;
        // margin:35px 10px 0 37px;
        // float: left;
        img{
            width:100%;
            height:250px;
        }
        .p1{
            width:80%;
            padding:0 20px;
            margin:10px auto 0 auto;
            text-align:left;
            font-size:16px;
            color:#444444;
        }
        .p2{
            width:80%;
            margin: 15px auto 0 auto;
            font-size:13px;
            line-height:22px;
            // height:50px;
            color:#999999;
        }
        .p3{
            box-sizing: border-box;
            width:80%;
            margin:0 auto;
            padding-left: 20px;
            background: url(../assets/image/home/home-img6.png) no-repeat 0 center;
            font-size:14px;
            color:#444444;
            position: absolute;
            bottom:15px;
            left:10%;
        }
    }
</style>